import { Back } from '@icon-park/react';
import { noop } from 'lodash';
import { type MouseEventHandler, memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Typography } from '@didaskill/ui/design-system';

import Forbidden from '../../../../assets/images/Forbidden.svg';
import messages from './ForbiddenError.messages';
import * as styles from './ForbiddenError.styles';

export type ForbiddenErrorProps = {
  onReturnToHome?: MouseEventHandler<HTMLButtonElement>;
};

export const ForbiddenErrorBase = ({ onReturnToHome = noop }: ForbiddenErrorProps) => (
  <div css={styles.content}>
    <div css={styles.imageContainer}>
      <Forbidden />
    </div>

    <Typography variant={Typography.VARIANTS.HEADING_3} css={styles.title}>
      <FormattedMessage {...messages.FORBIDDEN_TITLE} />
    </Typography>

    <Typography variant={Typography.VARIANTS.BODY_MEDIUM_BOLD}>
      <FormattedMessage {...messages.FORBIDDEN_DESCRIPTION} />
    </Typography>

    <Button
      variant={Button.VARIANTS.PRIMARY}
      outline
      icon={<Back />}
      onClick={onReturnToHome}
      css={styles.button}
    >
      <FormattedMessage {...messages.RETURN_TO_HOME} />
    </Button>
  </div>
);

ForbiddenErrorBase.displayName = 'ForbiddenError';

export const ForbiddenError = memo(ForbiddenErrorBase);
